import {TransferConstants} from "finhelper";

export const getIncomeTypes = (actionTypeId) =>
{
    let types = [
        {id: TransferConstants.BETWEEN_ACCOUNTS, name: 'Перевод между счетами'},
        {id: TransferConstants.INCOME, name: 'Доход'},
        {id: TransferConstants.SELL_OWN_ACTIVE, name: 'Продажа личного актива'},
        {id: TransferConstants.SELL_INVEST_ACTIVE, name: 'Продажа инвестиционного актива'},
        {id: TransferConstants.ADD_PAYMENT, name: 'Привязка платежа к активу'},
        {id: TransferConstants.CONNECT_PAYMENT, name: 'Привязка платежа к расходу'},
    ];
    //если выбран перевод между счеатми где участвует временный счет, то скрываем обычный перевод между счетами
    //в противном случае скрываем перевод между временными счетами, такие операция удаляются при пересчете
    //и создавать их нельзя
    if (typeof actionTypeId === TransferConstants.BETWEEN_ACCOUNTS_TEMP) {
        types = types.filter((item) => {
            return item.id !== TransferConstants.BETWEEN_ACCOUNTS;
        })
    } else {
        types = types.filter((item) => {
            return item.id !== TransferConstants.BETWEEN_ACCOUNTS_TEMP;
        })
    }

    return types;
}